import { TabType } from "../../../components/pageCollection/PageCollectionNavigation";

import {
  SELLAR_CREDIT_PAYMENT_ALLOCATION_HISTORY,
  SELLAR_CREDIT_STATEMENT,
  SELLAR_CREDIT_TAB,
} from "../../../constants/routes";
import { withSearchParams } from "../../../utils/withSearchParams";

export const tabsLeft = ({
  provider,
  scPaymentAllocationHistoryEnabled,
}: {
  provider: "hokodo" | "two";
  scPaymentAllocationHistoryEnabled: boolean;
}): TabType[] => {
  return [
    {
      label: "Tab",
      route: withSearchParams(SELLAR_CREDIT_TAB, { provider }),
    },
    {
      label: "Statement",
      route: withSearchParams(SELLAR_CREDIT_STATEMENT, { provider }),
    },
    scPaymentAllocationHistoryEnabled &&
      provider === "two" && {
        label: "History",
        route: withSearchParams(SELLAR_CREDIT_PAYMENT_ALLOCATION_HISTORY, {
          provider,
        }),
      },
  ].filter(Boolean) as TabType[];
};
